<div class="row">
  <div class="col-xs-12 col-sm-12 col-md-6 mx-auto">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">
          Zertifikat {{ getActionText() }}
        </h3>
      </div>

      <div class="card-body">
        <form (submit)="onSubmit()" [formGroup]="form" class="form-horizontal">
          <app-form-group [biggerLabel]="true" [group]="form" label="Zertifikatsdatei" control="file">
            <div class="input-wrapper">
                Datei auswählen
                <input class="file-input file-input-hidden" type="file" name="file" (change)="onFileSelected($event)"/>
            </div>
            <div class="file-input-selection" *ngIf="file"> {{ file.name }}</div>
          </app-form-group>

          <div class="row">
            <div class="offset-sm-3 col-sm-9">
              <button class="btn btn-primary" type="submit">Speichern</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
